export const fieldObjectFluxosProaq = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'proaq.id',
];

export const valoresExibidosOffCanvasFluxoProaq: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorChaves: '',
  separadorIdentificacao: '',
  separadorItens: '',
  separadorObservacoes: '',

  //Específicos
  status: 'Status',
  modalidade: 'Mod. Aquisição',
  nomeModelo: 'Nome do Modelo',
  coordenacao: 'Coordenação',
  nFases: 'Fases',
};

export const valoresExibidosOffCanvasFluxoProaqFase: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorObservacoes: '',

  //Específicos
  ordem: 'Ordem',
  estimativaDias: 'Estimativa (dias)',
  areaResponsavel: 'Área Responsável',
  nomeFase: 'Nome',
  descricao: 'Descrição',
};

export const headersFluxosProaqs = [
  { text: '', width: 1, key: '1' },
  { text: 'ID', width: 2, key: '2' },
  { text: 'Status', width: 5, key: '3' },
  { text: 'Mod. Aquisição', width: 15, key: '4' },
  { text: 'Coordenação', width: 15, key: '5' },
  { text: 'N° Fases', width: 22, key: '6' },
  { text: 'Nome', width: 40, key: '7' },
  { text: 'Proaqs', width: 10, key: '8' },
];

export const headersFluxosProaqFases = [
  { text: '', width: 1, key: '1' },
  { text: 'ID', width: 2, key: 'idFluxoFase' },
  { text: 'Ordem', width: 5, key: 'ordemFluxoFase' },
  { text: 'Estimativa', width: 10, key: 'estimativaFluxoFase' },
  { text: 'Area Responsável', width: 12, key: 'responsavelFluxoFase' },
  { text: 'Nome', width: 70, key: 'nomeFluxoFase' },
];
